import React, { useContext } from "react";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";
import UserProgressContext, { UserProgressProvider } from "./userProgressContext";
import EntryPage from "./components/EntryPage/entryPage";
import GameLevelLayout from "./components/Layout/gameLevelLayout";
import RootLayout from "./components/Layout/rootLayout";
import GameLevel from "./components/GameLevels/gameLevel";
import NotFound from "./notFound";
import GridGuardArsenal from "./components/GridGuardArsenal/gridGuardArsenal";
import ResourceDetails from "./components/GridGuardArsenal/resourceDetails";
import SecurityAlert from "./components/Visuals/securityAlert";
import CyberChallenge from "./components/CyberChallenge/cyberChallenge";
import AwardBadge from "./components/Badge/badge";
import GameResumePrompt from "./components/GameResume/gameResumePrompt";
import DefenseScoreHUD from "./components/UI/DefenseScoreHUD";
import LevelEntryGate from "./components/Cinematic/LevelEntryGate";
import EducatorDashboard from "./components/Educator/EducatorDashboard";
import DifficultySelect from "./components/Difficulty/DifficultySelect";
import { PUBLIC_URL } from "./utils/publicPath";

function RequireUser() {
  const { name, emailId } = useContext(UserProgressContext);
  return name && emailId ? <Outlet /> : <Navigate to="/" replace />;
}

export default function App() {
  return (
    <UserProgressProvider>
      <BrowserRouter basename={PUBLIC_URL}>
        <DefenseScoreHUD />
        <RootLayout>
          <Routes>
            <Route path="/" element={<EntryPage />} />
            <Route path="/difficulty" element={<DifficultySelect />} />

            <Route
              path="/*"
              element={
                <Routes>
                  <Route element={<RequireUser />}>
                  <Route
                    path="/level/:levelId"
                    element={
                      <LevelEntryGate>
                        <GameLevelLayout>
                          <GameLevel />
                        </GameLevelLayout>
                      </LevelEntryGate>
                    }
                  />
                  <Route path="/gameResume" element={<GameResumePrompt />} />
                  <Route
                    path="/gridGuardArsenal"
                    element={
                      <GameLevelLayout>
                        <GridGuardArsenal />
                      </GameLevelLayout>
                    }
                  />
                  <Route
                    path="/gridGuardArsenal/:resourceId"
                    element={
                      <GameLevelLayout>
                        <ResourceDetails />
                      </GameLevelLayout>
                    }
                  />
                  <Route
                    path="/securityAlert"
                    element={
                      <GameLevelLayout>
                        <SecurityAlert />
                      </GameLevelLayout>
                    }
                  />
                  <Route
                    path="/cyberChallenge"
                    element={
                      <GameLevelLayout>
                        <CyberChallenge />
                      </GameLevelLayout>
                    }
                  />
                  <Route path="/gameover" element={<AwardBadge />} />
                  </Route>

                  <Route path="/educator" element={<EducatorDashboard />} />

                  <Route path="*" element={<NotFound />} />
                  {/* <Route
                    path="level-1"
                    element={
                      <GameLevelLayout>
                        <GameLevel />
                      </GameLevelLayout>
                    }
                  /> */}
                </Routes>
              }
            />
          </Routes>
        </RootLayout>
      </BrowserRouter>
    </UserProgressProvider>
  );
}
